import { useEffect, useState } from 'react';

import { handleAxiosError } from 'core/notifications';

import axios from '@/util/axios';

export default ({
  getEnqueueAxiosConfig,
  getPreviewAxiosConfig,
  initialData,
  settingsAxiosConfig,
}) => {
  const [dataErrors, setDataErrors] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [model, setModel] = useState(initialData);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setSettings((await axios(settingsAxiosConfig)).data.data);
      } catch (error) {
        return handleAxiosError(error);
      }

      setIsLoading(false);
    };

    fetchSettings();
  }, [settingsAxiosConfig]);

  const handleError = (error) => {
    const { response } = error;

    return response?.status === 422
      ? setDataErrors(response.data?.errors)
      : handleAxiosError(error);
  };

  const fetchPreview = async () => {
    setIsSubmitting(true);
    setDataErrors(null);

    try {
      setModel({ ...model, ...(await axios(getPreviewAxiosConfig(model))).data.data });
    } catch (error) {
      handleError(error);
    }

    setIsSubmitting(false);
  };

  const enqueueImport = async () => {
    let hasEnqueued = false;

    setIsSubmitting(true);

    try {
      hasEnqueued = (await axios(getEnqueueAxiosConfig(model))).status === 204;
    } catch (error) {
      handleError(error);
    }

    setIsSubmitting(false);

    return hasEnqueued;
  };

  return {
    dataErrors,
    enqueueImport,
    fetchPreview,
    isLoading,
    isSubmitting,
    model,
    setModel,
    settings,
  };
};
